import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'signup-success-verification-form',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './signup-success-verification-form.component.html',
  styleUrl: './signup-success-verification-form.component.scss',
})
export class SignupSuccessVerificationFormComponent implements OnInit{
  @Input('appName') appName!: string;
  @Output('navigateToLogin') navigateToLoginEvent = new EventEmitter<void>();
  logoUrl = ``
  backgroundImageId = ``
  ngOnInit(): void {
    if(this.appName == "arenaEqApp"){
      this.backgroundImageId = 'intro-arena'
      this.logoUrl = `assets/images/arenaEq-logo.png`
    }else{
      this.logoUrl = `../../../assets/images/access-logo-full.png`
      this.backgroundImageId = 'intro-iea'
    }
  }
  navigateToLogin() {
    this.navigateToLoginEvent.emit();
  }

}
